import { Injectable } from '@angular/core';
import { CommunicationService } from '../services/communication.service';
import { Observable } from 'rxjs';
import { AcceptInvitationRequestModel, TechnicianPersonalDetails } from './invite-registration.models';

@Injectable()
export class InviteRegistrationService {
  constructor(private communicationService: CommunicationService) {}

  getTechnicianDetailsByLink(link: string): Observable<TechnicianPersonalDetails> {
    return this.communicationService.getData<TechnicianPersonalDetails>(`technician/link/${link}`);
  }

  acceptInvitation(model: AcceptInvitationRequestModel): Observable<any> {
    return this.communicationService.updateData('registration/accept-invitation', model);
  }
}
